import { useState, useEffect } from 'react';

const STORAGE_KEY = 'quest_runner_history';

export const useWorkoutHistory = () => {
  const [history, setHistory] = useState([]);
  const [stats, setStats] = useState({
    totalSessions: 0,
    totalSteps: 0,
    totalDistance: 0, // km
    totalTime: 0, // minutes
  });

  useEffect(() => {
    loadHistory();
  }, []);

  const loadHistory = () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsedHistory = JSON.parse(stored);
        // Sortăm descrescător după dată (cel mai recent primul)
        const sortedHistory = parsedHistory.sort((a, b) => new Date(b.date) - new Date(a.date));
        setHistory(sortedHistory);
        calculateStats(sortedHistory);
      }
    } catch (e) {
      console.error("Failed to load history", e);
    }
  };

  const calculateStats = (data) => {
    const newStats = data.reduce((acc, session) => ({
      totalSessions: acc.totalSessions + 1,
      totalSteps: acc.totalSteps + (session.steps || 0),
      totalDistance: acc.totalDistance + (session.distance || 0),
      totalTime: acc.totalTime + (session.duration || 0)
    }), { totalSessions: 0, totalSteps: 0, totalDistance: 0, totalTime: 0 });

    // Rotunjim distanța
    newStats.totalDistance = parseFloat(newStats.totalDistance.toFixed(2));
    // Rotunjim timpul
    newStats.totalTime = Math.round(newStats.totalTime);

    setStats(newStats);
  };

  const saveSession = (sessionData) => {
    try {
      const newEntry = {
        id: Date.now(),
        date: new Date().toISOString(),
        ...sessionData
      };

      const updatedHistory = [newEntry, ...history];
      setHistory(updatedHistory);
      calculateStats(updatedHistory);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedHistory));
      return true;
    } catch (e) {
      console.error("Failed to save session", e);
      return false;
    }
  };

  const clearHistory = () => {
    localStorage.removeItem(STORAGE_KEY);
    setHistory([]);
    setStats({ totalSessions: 0, totalSteps: 0, totalDistance: 0, totalTime: 0 });
  };

  return {
    history,
    stats,
    saveSession,
    clearHistory,
    refreshHistory: loadHistory
  };
};